// reactstrap 9.2.3 builds PopperContent's default `transition` by spreading Fade.defaultProps,
// but Fade moved its defaults inside the component, so the spread yields {}. Every tooltip and
// popover then renders with `transition.timeout` undefined and logs "The prop `transition.timeout`
// is marked as required in `PopperContent`". Restore the timeout Fade itself defaults to (150 ms).
// Imported once by index.js (the app) and setupTests.ts (jest).
// Neither name is in reactstrap's type definitions, though both are runtime exports.
import * as reactstrap from "reactstrap";

const { PopperContent, Util } = reactstrap as unknown as {
    PopperContent?: { defaultProps?: { transition?: object } };
    Util?: { TransitionTimeouts?: { Fade?: number } };
};
// Guarded: if a reactstrap upgrade drops either name, tooltips keep the old warning rather than
// the whole app failing at startup.
const popperDefaults = PopperContent?.defaultProps;
const fadeTimeout = Util?.TransitionTimeouts?.Fade;

if (popperDefaults && fadeTimeout !== undefined) {
    popperDefaults.transition = {
        timeout: fadeTimeout,
        ...popperDefaults.transition,
    };
}
